import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceTest  {
    _originalTypeClassName = "zERP.BO.InvoiceTest";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceTest.translate = translateService;
}
this.Errors = [];
this.InvoiceTestKey = null;
this._key = this.InvoiceTestKey = 0; 
}

static translate: TranslateService;
_key: any;
Invoice:any;
Errors:any;
IncomeReceipt:any;
private _InvoiceTestKey:any;
get InvoiceTestKey(): any {
    return this._InvoiceTestKey;
  }
set InvoiceTestKey(value: any) {
    this._InvoiceTestKey = value;
    this._key = value;
  }
static setInvoice = ($this, value) => {
var oldValue = $this.Invoice;
$this.Invoice = value;
if (value != null) {
}
}
static setErrors = ($this, items) => {
                if (items == null) items = [];
                if ($this.Errors == null) $this.Errors = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Errors.length > 0) {
                    Domain.InvoiceTest.removeErrors($this, $this.Errors[0]);
                }

                Domain.InvoiceTest.addManyErrors($this, copyItems);
            }
static addManyErrors = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceTest.addErrors($this, items[i]);
                }
            }
static addErrors = ($this, item) => {
                if ($this.Errors == null) $this.Errors = [];
                if (item == null || $this.Errors.indexOf(item) > -1) return;
                $this.Errors.push(item);
}
static addRangeErrors = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceTest.addErrors($this, item));
            }
static removeErrors = ($this, item) => {
                if ($this == null || $this.Errors == null || $this.Errors.indexOf(item) === -1) return;
                var _index = $this.Errors.indexOf(item);
                $this.Errors.splice(_index, 1);
}
static clearErrors = ($this) => { $this.Errors = null; }
static setIncomeReceipt = ($this, value) => {
var oldValue = $this.IncomeReceipt;
$this.IncomeReceipt = value;
if (value != null) {
}
}

static AddError(error: any,errors: any): any{let err = new Domain.InvoiceTestError();
err.Description = error;
errors?.add(err);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InvoiceTestKey == null || $this.InvoiceTestKey == 0;
            }


}